export default __webpack_public_path__ + "static/media/02_moon.0baac495.JPG";